import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/pipeline")({
  beforeLoad: requirePermissionGuard("hca.op.read"),
});
